define('drops/entityFiltersPanel/entityFiltersPanelItem',[
    'jquery',
    'underscore',
    'tpl!./entityFiltersPanelItem.html'
], function ($, _, template) {
    'use strict';

    var EntityFiltersPanelItem = function (filterInstance) {
        this.$element = $(template({
            title: filterInstance.filter.data.title
        }));
        this.filterInstance = filterInstance;

        this.editingSettings = this.showAsPopupOpen.bind(this);
        this.settingsApplied = this.showAsPopupApplied.bind(this);
    };

    EntityFiltersPanelItem.prototype.show = function () {
        this.filterInstance.withOnEditingSettings(this.editingSettings);
        this.filterInstance.withOnSettingsApplied(this.settingsApplied);

        this.$remove = this.$element
            .find('.remove')
            .on('click', this.removeClicked.bind(this));
        
        if (this.filterInstance.options.modalPopup) {
            this.$element
                .addClass('has-settings')
                .on('click', this.clicked.bind(this));

            if (!this.filterInstance.hasInitialValue)
                this.showSettingsPopup();
        }

        this.$element.addClass('fade-in');
    };

    EntityFiltersPanelItem.prototype.remove = function () {
        var $element = this.$element;

        this.$element.slideUp({
                done: function () {
                    $element.remove();
                }
            })
            .css('pointer-events', 'none')
            .find('*').addBack().off('click');

        this.filterInstance.withoutOnEditingSettings(this.editingSettings);
        this.filterInstance.withoutOnSettingsApplied(this.settingsApplied);
    };

    EntityFiltersPanelItem.prototype.clicked = function (e) {
        if (e.target === this.$remove[0])
            return;
        
        if (this.$element.hasClass('settings-is-open')) {
            this.hideSettingsPopup();
            this.executeFilterChanges();
        } else {
            this.showSettingsPopup();
        }
    };

    EntityFiltersPanelItem.prototype.showSettingsPopup = function () {
        this.filterInstance.showSettingsPopup(this.$element);
    };

    EntityFiltersPanelItem.prototype.showAsPopupOpen = function () {
        this.$element.addClass('settings-is-open');
    };
    
    EntityFiltersPanelItem.prototype.hideSettingsPopup = function () {
        this.filterInstance.applySettingsFromPopup();
    };

    EntityFiltersPanelItem.prototype.showAsPopupApplied = function () {
        this.$element.removeClass('settings-is-open');
    };
    
    EntityFiltersPanelItem.prototype.removeClicked = function () {
        this.filterInstance.remove();
    };

    EntityFiltersPanelItem.prototype.executeFilterChanges = function () {
        this.filterInstance.executeFilterChanges();
    };
    
    return EntityFiltersPanelItem;
});

